import LoginBody from '../../components/logincomponents/LoginBody';
import TestFooter from '../../components/common/TestFooter';


function LoginPage({onLogin}) {
  const intendedUrl = localStorage.getItem("intendedUrl");
  console.log("[LoginPage] intendedUrl on mount:", intendedUrl);
  //localStorage.clear();
  if (intendedUrl) {
    localStorage.setItem("intendedUrl", intendedUrl);
  }
  
  return (
    <div>
     {/* <Nav /> */}
    <LoginBody handleLogin={onLogin}/>
    <TestFooter />
    </div>
  )
}
export default LoginPage;